module.exports = __webpack_public_path__ + "assets/tidy-icon.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tidy-icon.svg
// module id = 1107
// module chunks = 7